import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FormComponent } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';
export interface AmexAgreementFormModel {
  clientName: string,
  clientAddress: string,
  clientOccupation: string,
  clientEmployerNameAddress: string,
  clientTitlePosition: string,
  clientEmployerFunction: string
}
@Component({
  selector: 'td-wb-amex-agreement',
  templateUrl: './amex-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AmexAgreementComponent extends AgreementsDateBaseDirective {
  @ViewChild(FormComponent) form: FormComponent;
  @ViewChild('btn') btn: ElementRef;

  formModel: AmexAgreementFormModel = {
    clientName: '',
    clientAddress: '',
    clientOccupation: '',
    clientEmployerNameAddress: '',
    clientTitlePosition: '',
    clientEmployerFunction: ''
  };

  trySubmitAndReturnModel(): AmexAgreementFormModel {
    return super.trySubmit(this.form) ? this.formModel : undefined;
  }
}
